import {z} from 'zod'

export const JourneyTypeSchema = z.enum(['ONE_TIME', 'RECURRENT'])

export type JourneyType = z.infer<typeof JourneyTypeSchema>
